import { TTableViewState } from '@/shared/features/filter-preferences/hooks/use-table-view-state/use-table-view-state.types';
import {
  clearTableView,
  readTableView,
  seedTableViewColumns,
  writeTableView,
} from '@/shared/features/filter-preferences/storage/table-state-storage/table-state-storage';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';
import { TStoredColumnState } from '@/shared/types/ui-preferences.types';

// Reads go straight to storage, not React state: the snapshot is only ever read
// once per mount, before the first render that matters.
export const useTableViewState = (scopeKey: string): TTableViewState => {
  const user = useAppSelector(selectUser);
  const tenantId = user?.attributes?.['custom:tenantId'] ?? '';

  return {
    readSnapshot: () => readTableView(tenantId, scopeKey),
    saveQuery: (query: string) => writeTableView(tenantId, scopeKey, { query }),
    saveColumns: (columns: TStoredColumnState[]) =>
      writeTableView(tenantId, scopeKey, { columns }),
    seedColumns: (columns: TStoredColumnState[]) =>
      seedTableViewColumns(tenantId, scopeKey, columns),
    clearSnapshot: () => clearTableView(tenantId, scopeKey),
  };
};
